import '.ab{position:relative;}.ssr-plugin'
import '.cc{display:inline-flex;}.ssr-plugin'
import '.t{align-items:center;}.ssr-plugin'
import '.ee{align-self:flex-start;}.ssr-plugin'
import '.ef{padding:3px;}.ssr-plugin'
import '.eg{background:var(--palette-blue-50);}.ssr-plugin'
import '.eh{border:0.5px solid var(--gray-200);}.ssr-plugin'
import '.cq{border-radius:0.75rem;}.ssr-plugin'
import '.bi{position:absolute;}.ssr-plugin'
import '.ei{top:3px;}.ssr-plugin'
import '.bk{left:0px;}.ssr-plugin'
import '.ej{width:0px;}.ssr-plugin'
import '.ek{height:calc(100% - 6px);}.ssr-plugin'
import '.eb{background:var(--palette-white);}.ssr-plugin'
import '.el{border:0.5px solid var(--gray-300);}.ssr-plugin'
import '.em{border-radius:calc(0.75rem - 3px);}.ssr-plugin'
import '.en{box-shadow:0 1px 3px rgba(0, 0, 0, 0.08);}.ssr-plugin'
import '.cp{pointer-events:none;}.ssr-plugin'
import '.eo{z-index:1;}.ssr-plugin'
import '.d{display:flex;}.ssr-plugin'
import '.ah{justify-content:center;}.ssr-plugin'
import '.ep{gap:0.375rem;}.ssr-plugin'
import '.eq{padding-block:6px;}.ssr-plugin'
import '.er{padding-inline:18px;}.ssr-plugin'
import '.cu{background:transparent;}.ssr-plugin'
import '.by{border:none;}.ssr-plugin'
import '.a1{cursor:pointer;}.ssr-plugin'
import '.dg{user-select:none;}.ssr-plugin'
import '.es{white-space:nowrap;}.ssr-plugin'
import '.ak{flex:1;}.ssr-plugin'
import { useCallback, useLayoutEffect, useRef } from 'react'
import { Style, styled } from 'inlines'
import { Text } from '../typography/Text'

export type ToggleOption<T> = {
  label: string
  value: T
  style?: Style
}

export type ToggleProps<T> = {
  options: ToggleOption<T>[]
  selectedOption: T
  setSelectedOption: (option: T) => void
  style?: Style
}

const PILL_TRANSITION =
  'left 0.28s cubic-bezier(0.34, 1.3, 0.64, 1), width 0.28s cubic-bezier(0.34, 1.3, 0.64, 1)'

export const Toggle = <T extends string | boolean>({
  options,
  selectedOption,
  setSelectedOption,
  style,
}: ToggleProps<T>) => {
  const containerRef = useRef<HTMLDivElement>(null)
  const pillRef = useRef<HTMLDivElement>(null)
  const itemRefs = useRef<(HTMLButtonElement | null)[]>([])

  const updatePill = useCallback(() => {
    const selectedIndex = options.findIndex(
      (option) => option.value === selectedOption,
    )
    const activeEl = itemRefs.current[selectedIndex]
    const pill = pillRef.current

    if (!activeEl || !pill) {
      return
    }

    pill.style.left = `${activeEl.offsetLeft}px`
    pill.style.width = `${activeEl.offsetWidth}px`
  }, [options, selectedOption])

  useLayoutEffect(() => {
    const container = containerRef.current
    if (!container) {
      return
    }

    updatePill()

    const observer = new ResizeObserver(() => {
      updatePill()
    })
    observer.observe(container)

    return () => observer.disconnect()
  }, [updatePill])

  return (
    <styled.div className="ab cc t ee ef eg eh cq"
      ref={containerRef}
      style={{
        ...style,
      }}
    >
      <div className="bi ei bk ej ek eb el em en cp"
        ref={pillRef}
        aria-hidden="true"
        style={{
          transition: PILL_TRANSITION,}}
      />
      {options.map((option, index) => {
        const isActive = selectedOption === option.value

        return (
          <styled.button className="ab eo d t ah ep eq er cu by em a1 dg es ak"
            key={String(option.value)}
            type="button"
            ref={(element) => {
              itemRefs.current[index] = element
            }}
            onClick={() => setSelectedOption(option.value)}
            style={{
              ...(!isActive && {
                '&:hover span': {
                  color: 'var(--brand-secondary)',
                },
              }),
              ...option.style,
            }}
          >
            <Text.Medium
              color={
                isActive
                  ? 'var(--brand-secondary)'
                  : 'var(--palette-blue-400)'
              }
              isBold={isActive}
              style={{ transition: 'color 0.18s' }}
            >
              {option.label}
            </Text.Medium>
          </styled.button>
        )
      })}
    </styled.div>
  )
}
